module.exports = __webpack_public_path__ + "scripts/bubbles.svg?906f8ab5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error/bubbles.svg
// module id = 1322
// module chunks = 1